module.exports = __webpack_public_path__ + "img/promotion-3.5e31c4b8.png";